import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleValidateTimeRecordsUpToDateRequest(
  resource: Identifiable<Resource>,
  {
    date,
    resource: r,
  }: Boundaries["validatePersonalTimeRecordsUpToDate"]["request"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid
    ? { ...resource, integratedAt: date }
    : resource;
}

function handleValidateTimeRecordsUpToDateSuccess(
  resource: Identifiable<Resource>,
  {
    date,
    resource: r,
  }: Boundaries["validatePersonalTimeRecordsUpToDate"]["success"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid
    ? { ...resource, integratedAt: date }
    : resource;
}

function handleValidateTimeRecordsUpToDateFailure(
  resource: Identifiable<Resource>,
  { resource: r }: Boundaries["validatePersonalTimeRecordsUpToDate"]["failure"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid ? r : resource;
}

export {
  handleValidateTimeRecordsUpToDateRequest,
  handleValidateTimeRecordsUpToDateSuccess,
  handleValidateTimeRecordsUpToDateFailure,
};
